<ng-container matColumnDef="portableApplianceTestingDays">
  <mat-header-cell [crud-column-header]="columns.column('portableApplianceTestingDays')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.ElectricalAspect.portableApplianceTestingDays">
      Portable Appliance Testing Days 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'portableApplianceTestingDays', electricalAspectGetter, previousRevisionGetter)">
    {{electricalAspectGetter(element)?.portableApplianceTestingDays | number:'1.0-2':'en-GB'}}
  </mat-cell>
</ng-container>  